export default {
  name: 'SimpleTab',
  props: {
    /**
     * @type {Array<{label: string, slot?: string, content?: string}>}
     */
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeTabIdx: 0
    }
  },
  render(h) {
    if (this.items.length === 0) {
      return h('div')
    }

    const tabContents = []
    for (const item of this.items) {
      let scoped = null
      if (item.slot) {
        scoped = this.$scopedSlots[item.slot] || null
      }
      if (scoped === null) {
        scoped = this.$scopedSlots['item']
      }
      const tabContent = scoped ?
        scoped({ item }) :
        item.content || ''
      tabContents.push(tabContent)
    }

    return h('div', { class: 'tab-wrapper' }, [
      h('style', { attrs: { scoped: true } },
        [`
          .tab-wrapper {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            --tab-border-color: #ddd;
          }
          .tab {
            display: flex;
            justify-content: flex-start;
            gap: 0.5rem;
            border: solid 1px var(--tab-border-color);
            border-radius: 4px;
            padding: 0.5rem;
          }
          .tab button {
            font-family: 'Cera Pro', sans-serif;
            padding: 0.5rem 1rem;
            border: 1px solid #ccc;
            border-radius: 4px;
            background-color: #fff;
            cursor: pointer;
          }
          .tab button.active {
            background-color: #ddd;
          }
          .tab-content-wrapper {
            padding: 10px;
            border: 1px solid var(--tab-border-color);
            border-radius: 4px;
          }
          .tab-content {
            display: none;
          }
          .tab-content.active {
            display: block;
          }
        `]
      ),
      h('div', { class: 'tab' }, this.items.map((item, idx) => {
        return h('button', {
          class: { active: this.activeTabIdx === idx },
          on: { click: () => this.activeTabIdx = idx }
        }, item.label)
      })),
      h('div', { class: 'tab-content-wrapper' },
        tabContents.map((tabContent, idx) => {
          return h('div', {
            class: `tab-content ${this.activeTabIdx === idx ? 'active' : ''}`
          }, tabContent)
        })
      )
    ])
  }
}
